import LocalizedStrings from 'localized-strings';

import { IdDocumentCase } from '__generated__/GQL';

export const locales = new LocalizedStrings({
  en: {
    cta: 'Continue',
    steps: {
      id: {
        description: 'Valid identity card, passport or residence permit',
        title: {
          [IdDocumentCase.AcceptedPassportOrIdCard]: `You’ll need an ID`,
          [IdDocumentCase.ValidResidencyCard]: 'Get your residence permit',
          [IdDocumentCase.ExpiredResidencyCard]: 'Get your passport',
          [IdDocumentCase.Visa]: 'Get your passport',
          [IdDocumentCase.NoDocument]: 'Get your passport',
        },
      },
      photo: {
        description: 'The photo will remain completely confidential',
        title: 'Take a photo of yourself with your smartphone',
      },
      verification: {
        title: 'We verify your identity',
      },
    },
    subtitle:
      'This step allows us to confirm that you are who you say you are. You will be redirected to our partner’s platform',
    title: 'Verify your identity',
  },
  fr: {
    cta: 'Continuer',
    steps: {
      id: {
        description: 'Carte d’identité, passeport ou titre de séjour valide',
        title: {
          [IdDocumentCase.AcceptedPassportOrIdCard]:
            'Munissez-vous d’une pièce d’identité',
          [IdDocumentCase.ValidResidencyCard]:
            'Munissez-vous de votre titre de séjour',
          [IdDocumentCase.ExpiredResidencyCard]:
            'Munissez-vous de votre passeport',
          [IdDocumentCase.Visa]: 'Munissez-vous de votre passeport',
          [IdDocumentCase.NoDocument]: 'Munissez-vous de votre passeport',
        },
      },
      photo: {
        description: 'La photo reste entièrement confidentielle',
        title: 'Prenez-vous en photo avec votre smartphone',
      },
      verification: {
        title: 'Nous vérifions votre identité',
      },
    },
    subtitle:
      'Cette étape nous permet de confirmer que vous êtes la personne que vous indiquez être. Vous serez redirigé·e vers la plateforme de notre partenaire.',
    title: 'Vérifiez votre identité',
  },
} as const);
